import * as _ from "lodash";
import * as types from './action-types';
import { IGalaContactsState } from "./state";

var initialState: IGalaContactsState = {
    list: []
}

export const Reducer = (state: IGalaContactsState = initialState, action: any) => {

    let s = _.cloneDeep(state);
    switch (action.type) {
        case types.SET_GALACONTACTS:
            s.list = action.list;
            return s;
    }

    return s;
}